import * as React from "react";

import { ButtonProps } from "./Button";

export const ButtonTestPageObject = (props: ButtonProps, handleClick: () => void) => ({
    click: (): void => {
        handleClick();
    },

    isDisabled: (): boolean => Boolean(props.disabled),

    getButtonText: () => {
        if (props.value) {
            return props.value;
        }
        if (props.children) {
            const arrayChildren = React.Children.toArray(props.children);
            const item = arrayChildren?.filter(arrayItem => typeof arrayItem === "string")[0];
            return item?.toString().trim();
        }
        return "";
    },

    getType: () => "Button",

    hasError: () => Boolean(props.error),

    hasWarning: () => Boolean(props.warning),
});
